module.exports = __webpack_public_path__ + "static/img/mainpic.324b907.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/mobile/mainpic.jpg
// module id = XYBE
// module chunks = 1